<template>
  <b-container fluid class="composeEmail">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          Compose Email
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Email Subject" v-model="emailSubject">
          <div class="prefixIcon"><i class="material-icons">email</i></div>
        </div>
        <VueTrix inputId="editor1" v-model="emailContent"/>
        <div class="generalBtn p-3 text-center text-uppercase" v-on:click="showBox()" v-if="!showConfirmationBox">
          Blast Email
        </div>
        <div v-if="showConfirmationBox">
          <div class="p-3 text-center text-uppercase">
            Are you sure?
            <b-row class="mt-3">
              <b-col lg="6" md="6" sm="6" xs="6" class="noBtn p-3 text-center text-uppercase" v-on:click="hideBox()">
                No
              </b-col>
              <b-col lg="6" md="6" sm="6" xs="6" class="yesBtn p-3 text-center text-uppercase" v-on:click="blastEmail()">
                Yes
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// doc: https://githubcom/basecamp/trix#readme
import util from '@/util'
import VueTrix from 'vue-trix'

export default {
  name: 'ComposeEmail',
  data () {
    return {
      emailSubject: '',
      emailContent: '',
      showConfirmationBox: false
    }
  },
  components: {
    VueTrix
  },
  methods: {
    resetForm () {
      this.$data.emailSubject = ''
      this.$data.emailContent = ''
      var element = document.querySelector('trix-editor')
      element.editor.element.value = ''
    },
    showBox () {
      this.showConfirmationBox = true
    },
    hideBox () {
      this.showConfirmationBox = false
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    blastEmail () {
      this.toast('Blasted!' + this.$data.emailContent, 'success', 'check')
      this.showConfirmationBox = false
      this.resetForm()
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  }
}
</script>

<style scoped>
.composeEmail {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.fieldWrapper {
  background-color: #fff;
  overflow: hidden;
  position: relative;
	display: inline;
}
.fieldWrapper input {
  border: none;
  border-bottom: 1px solid #000;
  padding: 10px 10px 10px 70px;
  width: 100%;
  outline: none;
  line-height: 1.5;
  margin-bottom: 15px;
}
.prefixIcon {
  background-color: #FF8F00;
  position: absolute;
  top: -11px;
  bottom: -11px;
  font-size: 2em;
  padding: 0px 20px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ComposeEmail.vue